import { gql } from "@apollo/client";

export const GET_FINDING_RAW_DATA = gql`
  query get_finding_by_id($id: ID!) {
    finding(id: $id) {
      id
      raw2
    }
  }
`;
